import request from '@/utils/request';
/**
 * 获取授权课件列表(我的课程)
 * @Int clients_id 校区ID. 个人可不传或传0
 */
export function fetchAuthCourse(params, clientsId) {
  return request({
    url: `/api/packet/packet-auth-list?clients_id=${clientsId}`,
    method: 'get',
    params: {
      'equal[auth_status]': 1,
      'order[created_at]': 'desc',
      ...params,
    },
  });
}
/**
 * 授权课件详情(我的课程)
 * @Int clients_id 校区ID. 个人可不传或传0
 */
export function fetchAuthCourseDetail(id, clientsId) {
  return request({
    url: `/api/packet/packet-auth-detail/${id}?clients_id=${clientsId}`,
    method: 'get',
  });
}
/**
 * 上课
 */
export function gotoClass(id) {
  return request({
    url: `/api/course/commodities/orders/${id}`,
    method: 'get',
  });
}



// WEBPACK FOOTER //
// ./src/api/myCourse.js